import { getPageContent,getCredCount,resolver } from './states';

export const services = {
  getPageContent,getCredCount,resolver
};
